<template>
  <div class="tg-tree--info">
    <template v-for="(propertyName, index) in columns">
      <p
        v-if="propertyName in info"
        class="tg-field"
        :key="index"
      >{{$t('component.tree.info.' + propertyName, {value: info[propertyName]})}}</p>
      <p :key="'P' + index" v-if="propertyName == 'usernickname'"></p>
    </template>
    <el-alert v-if="isDel == 1" title="此帐户已删除" type="warning" show-icon :closable="false"></el-alert>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        "create_hierarchy",
        "team_num",
        "parent_name",
        "tgbusiness_day",
        "usernickname"
        // "username",
        // "total_num",
        // "tg_business_nickname",
        // "member_level",
        // "parent_tg_business_nickname",
        // "directpush_num",
      ]
    };
  },
  props: {
    info: Object,
    isDel: [Number, String]
  }
};
</script>